import Head from "next/head";
import Image from "next/legacy/image";
import { useState, useEffect } from "react";
import { DEFAULT_CATEGORY_BANNER } from "../../../modules/site-structure/common/make-model-year-utils";

function BannerWithFallback(props: any) {
  const [isError, sethasError] = useState(false);
  const {
    src, fallbackImage, alt, onBannerClick, style = {}, // className, style, width, height,
    maintainAspectRatio, applyStyle = true, bannerAltText, bannerTitleText, fullWidthBanner,
  } = props;
  useEffect(() => {
    sethasError(false);
  }, [src]);
  let imageAlt = alt;

  if (!alt) {
    try {
      // eslint-disable-next-line prefer-destructuring
      imageAlt = src.match(/([^/]+)(?=\.\w+$)/)[0];
    } catch (e) {
      imageAlt = "";
    }
  }
  // const { currentPageType } = useSelector((state: RootState) => state.utils);

  if (fullWidthBanner) {
    return (
      <div className="text-center">
        <Image
          src={!isError ? src : fallbackImage || DEFAULT_CATEGORY_BANNER}
          alt={bannerAltText || `Discover ${imageAlt} For Your Vehicle`}
          title={bannerTitleText || `Discover ${imageAlt} For Your Vehicle`}
          onClick={onBannerClick}
          width={400}
          height={100}
          className="m-lr-auto"
        />
      </div>
    );
  }

  if (maintainAspectRatio) {
    return (
      <div>
        <Image
          unoptimized
          src={!isError ? src : fallbackImage || DEFAULT_CATEGORY_BANNER}
          alt={bannerAltText || `Discover ${imageAlt} For Your Vehicle`}
          title={bannerTitleText || `Discover ${imageAlt} For Your Vehicle`}
          width={1140}
          height={230}
          objectFit="cover"
          objectPosition="bottom"
          onError={() => sethasError(true)}
        />
      </div>
    );
  }

  return (
    <div style={{
      height: "100%",
      ...style,
    }}
    >
      <Head>

        <link rel="preload" as="image" href={src} />
      </Head>

      <div className="hidden-xs">
        <img
          // layout="intrinsic"
          // unoptimized
          src={!isError ? src : fallbackImage || DEFAULT_CATEGORY_BANNER}
          alt={bannerAltText || `Discover ${imageAlt} For Your Vehicle`}
          title={bannerTitleText || `Discover ${imageAlt} For Your Vehicle`}
          // height={265}
          // width={1296}
          // onError={() => sethasError(true)}
          style={{
            width: "100%",
            height: "100%",
          }}
          onClick={onBannerClick}
        />
      </div>

      <div className="visible-xs m-b-10">
        <img
          // layout="responsive"
          src={!isError ? src : fallbackImage || DEFAULT_CATEGORY_BANNER}
          // objectFit="contain"
          // unoptimized
          alt={`Discover ${imageAlt} For Your Vehicle`}
          title={`Discover ${imageAlt} For Your Vehicle`}
          // height={20}
          // width={69}
          onClick={onBannerClick}
          style={{
            width: "100%",
            height: "100%",
            minHeight: "calc(10.8 * var(--safari-root-font, 10px))",
            maxHeight: applyStyle ? "calc(10.8 * var(--safari-root-font, 10px))" : "auto",
          }}
        />
      </div>
      {/* <PAImage
        layout="fill"
        unoptimized
        src={!isError ? src : fallbackImage || DEFAULT_CATEGORY_BANNER}
        alt={imageAlt}
        height={250}
        width={1000}
        onError={() => sethasError(true)}
        // style={style}
        className={`${className} ${styles.top_banner}`}
        onClick={onBannerClick}
      /> */}

    </div>
  );
}

export default BannerWithFallback;
